var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"complete2"},[_c('div',{staticClass:"wrap"},[_c('Notification',{attrs:{"type":'onetimeOfferComplete'}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }